export default __webpack_public_path__ + "assets/0e94cde2005d7f7bea781581548e3b42.jpg";